export default "/app/global-wrapper-client/static/5da623347564d9a53595df7bcacc0603.woff2";